import { Box, Card, CardBody } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';

const HelpPage = () => {
  const ref = useRef();
  useEffect(() => {
    const src = import.meta.env.VITE_APP_URL_HELP_FORM_SCRIPT;
    if (ref.current.children.length === 0 && src) {
      const script = document.createElement('script');
      script.src = import.meta.env.VITE_APP_URL_HELP_FORM_SCRIPT;
      script.setAttribute('data-initial-height', '664px');
      script.setAttribute('style', 'display: block; height: 664px;');
      ref.current.appendChild(script);
    }
  }, []);
  return (
    <Card height="100%">
      <CardBody>
        <Box ref={ref} />
      </CardBody>
    </Card>
  );
};

export default HelpPage;
